import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import BackButton from "@/components/BackButton";

export default function EditSong() {
  const { id } = useParams();
  const nav = useNavigate();
  const [title, setTitle] = useState("");
  const [artist, setArtist] = useState("");
  const [lyrics, setLyrics] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/songs/${id}`);
        setTitle(data.title); setArtist(data.artist); setLyrics(data.lyrics);
      } catch (e) { toast.error(formatApiError(e)); nav("/library"); }
    })();
  }, [id, nav]);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch(`/songs/${id}`, { title, artist, lyrics });
      toast.success("Saved.");
      nav(`/songs/${id}`);
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <main data-testid="edit-song-page" className="max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-16">
      <BackButton to={`/songs/${id}`} label="Back to song" testid="edit-song-back-btn" />
      <p className="overline-label mt-6">Edit song</p>
      <h1 className="mt-2 font-serif text-4xl tracking-tight">Refine what's on stage.</h1>

      <div className="mt-8 space-y-5">
        <div className="grid sm:grid-cols-2 gap-3">
          <div>
            <Label className="overline-label">Title</Label>
            <Input value={title} onChange={(e) => setTitle(e.target.value)} className="mt-2 h-11" data-testid="edit-song-title" />
          </div>
          <div>
            <Label className="overline-label">Artist</Label>
            <Input value={artist} onChange={(e) => setArtist(e.target.value)} className="mt-2 h-11" data-testid="edit-song-artist" />
          </div>
        </div>
        <div>
          <Label className="overline-label">Lyrics</Label>
          <Textarea
            value={lyrics} onChange={(e) => setLyrics(e.target.value)}
            className="mt-2 min-h-[320px] font-serif text-lg leading-relaxed"
            data-testid="edit-song-lyrics"
          />
        </div>
      </div>

      <div className="mt-8 flex justify-end gap-3">
        <Button variant="ghost" className="rounded-full" onClick={() => nav(-1)}>Cancel</Button>
        <Button className="rounded-full h-11 px-6" onClick={save} disabled={saving} data-testid="edit-song-save-btn">
          {saving ? "Saving…" : "Save changes"}
        </Button>
      </div>
    </main>
  );
}
